import store from '@/store';
export default {
  inserted: function inserted(el, binding, vnode) {
    var value = binding.value;
    var permissionList = store.getters && store.getters.permissionList;
    if (!value) return el.parentNode && el.parentNode.removeChild(el);
    var modelId = vnode.context._routerRoot._route.meta.modelId || '';
    if (!modelId) return el.parentNode && el.parentNode.removeChild(el);
    var list = permissionList.filter(function (o) {
      return o.modelId === modelId;
    });
    if (!list.length) return el.parentNode && el.parentNode.removeChild(el);
    var btnList = list[0] && list[0].button ? list[0].button : [];
    if (!btnList.length) {
      el.parentNode && el.parentNode.removeChild(el);
    } else {
      var hasPermission = btnList.some(function (btn) {
        return btn.enCode === value;
      });
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    }
  }
};